<template>
  <div class="mt-4">
    <div class="container" v-if="studio">
      <div
        class="row"
        v-if="getPurchasedProducts && getPurchasedProducts.length"
      >
        <div class="col-12">
          <div class="border p-4 rounded">
            <div class="row">
              <div
                class="col-12 d-flex flex-row align-items-center justify-content-between mb-4"
              >
                <h3 class="m-0">{{ $t('GENERAL.LINK.MY_PRODUCTS') }}</h3>
              </div>
              <div
                class="col-sm-6 col-md-3 px-3"
                v-for="product in getPurchasedProducts"
                :key="product.id"
              >
                <NuxtLink
                  class="undecorated-router-link"
                  :to="{
                    name: 'studio-product',
                    params: { product_id: product.id },
                  }"
                >
                  <StudioProductCard :product="product" size="sm" />
                </NuxtLink>
              </div>
            </div>
          </div>
        </div>
      </div>
      <HMNoDataCard
        v-else
        :title="$t('PRODUCTS.TITLE.NO_PRODUCTS')"
        :description="$t('STUDIO.TEXT.NO_PRODUCTS_TEXT')"
        :toLabel="$t('STUDIO.BUTTON.BROWSE_PRODUCTS')"
        toRouteName="studio-shop"
      />
      <div
        class="row mt-4"
        id="class-cards-credits"
        v-if="punches && punches.length"
      >
        <div class="col-12">
          <div class="border p-4 rounded">
            <div class="row">
              <div class="col-12">
                <h3 class="mb-4">
                  {{ $t('STUDIO.TITLE.CLASS_CARD_CREDITS') }}
                </h3>
                <StudentClassCard class="w-100" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4" v-if="hasSolvedQuizzes">
        <div class="col-12">
          <div class="border p-4 rounded">
            <h3 class="mb-4">
              {{ $t('QUIZZES.TITLE.YOUR_QUIZ_SUBMISSIONS') }}
            </h3>
            <StudentSolvedQuizzesTable :items="solvedQuizzes" />
          </div>
        </div>
      </div>
    </div>
    <div class="text-center" v-else>
      <HMSpinner></HMSpinner>
    </div>
  </div>
</template>

<script>
import RefreshData from '@/mixins/refreshData';
import { mapState } from 'pinia';
import StudioProductCard from '@/components/products/StudioProductCard.vue';
import StudentSolvedQuizzesTable from '@/components/quizzes/StudentSolvedQuizzesTable.vue';
import StudentClassCard from '@/components/shop/StudentClassCard.vue';

import { useStudioStore, useUserStore, useStudentQuizStore } from '@/stores';

export default {
  name: 'StudentProducts',
  components: {
    StudioProductCard,
    StudentSolvedQuizzesTable,
    StudentClassCard,
  },
  mixins: [RefreshData],
  setup() {
    definePageMeta({
      name: 'studio-products',

      isStudio: true,
      requiresAuth: true,
      hideInstagramSlider: true,
      showStudentNavigation: true,
    })
  },
  data() {
    return {
      solvedQuizzes: [],
    };
  },
  computed: {
    ...mapState(useStudioStore, {
      studio: 'currentStudio',
      isOwner: 'isOwner',
    }),
    ...mapState(useUserStore, {
      punches: 'punches',
    }),
    sortedProducts() {
      if (!this.studio || !this.studio.products) return [];
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.studio.products.sort((p1, p2) => p1.position - p2.position);
    },
    getPurchasedProducts() {
      if (this.isOwner) return this.sortedProducts;
      return this.sortedProducts.filter(product => product.purchased);
    },
    hasSolvedQuizzes() {
      return this.solvedQuizzes?.length > 0;
    },
  },
  methods: {
    async loadData() {
      this.solvedQuizzes = await useStudentQuizStore().getSolvedQuizzes({
        studioURL: this.$studioURL,
      });
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/components-variables.scss';

:deep(.icon-container .icon) {
  border-radius: $border-radius;
}

:deep(.btn-container .add-button) {
  border-radius: $border-radius;
  padding: 4px 8px;
}
</style>